import React from "react";
import { Popup } from "semantic-ui-react";

export default function SelectList(props) {
  const { header, options, trigger, selections, onChange, onSelect } = props;

  function onOptionClick(option) {
    onSelect && onSelect(option);

    if (!selections || !onChange) return;

    if (selections.includes(option.value)) {
      onChange(selections.filter((selection) => selection !== option.value), option);
    } else {
      onChange([...selections, option.value], option);
    }
  }

  function isChecked(option) {
    return selections ? selections.includes(option.value) : false;
  }

  return (
    <Popup
      className="select-list"
      trigger={trigger}
      content={
        <React.Fragment>
          {header ? <div className="select-list-header">{header}</div> : null}
          <div className="select-list-content">
            <ul>
              {options.map((option) => {
                const checked = isChecked(option);

                return (
                  <li key={options.value} onClick={() => onOptionClick(option)}>
                    <input type="checkbox" checked={checked} onClick={(event) => event.stopPropagation()} />
                    <span>&nbsp;&nbsp;{option.label || option.value}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        </React.Fragment>
      }
      on="click"
      basic
      hideOnScroll
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/select_list.js